import type { CreateRepresentativeInput, UpdateRepresentativeInput } from '@idc-forms/schemas'
import { axiosPrivate } from '@/shared/api/axios'
import { buildListQueryString } from '@/shared/api/build-list-query-string'
import { API } from '@/shared/constants/api'
import type {
  PaginatedRepresentatives,
  RepresentativeAdminRow,
  RepresentativesAdminParams
} from '../models/representative-admin'

export async function getRepresentativesAdmin(
  params: RepresentativesAdminParams
): Promise<PaginatedRepresentatives> {
  const qs = buildListQueryString(params)
  const { data } = await axiosPrivate.get<PaginatedRepresentatives>(
    `${API.representatives.root}${qs ? `?${qs}` : ''}`
  )
  return data
}

/** Los payloads son los MISMOS schemas Zod que valida el backend. */
export async function createRepresentative(
  payload: CreateRepresentativeInput
): Promise<RepresentativeAdminRow> {
  const { data } = await axiosPrivate.post<RepresentativeAdminRow>(
    API.representatives.root,
    payload
  )
  return data
}

export async function updateRepresentative(
  id: string,
  payload: UpdateRepresentativeInput
): Promise<RepresentativeAdminRow> {
  const { data } = await axiosPrivate.patch<RepresentativeAdminRow>(
    API.representatives.byId(id),
    payload
  )
  return data
}

export async function deleteRepresentative(id: string) {
  const { data } = await axiosPrivate.delete(API.representatives.byId(id))
  return data
}
